import { render, staticRenderFns } from "./OrdemTrabalho.vue?vue&type=template&id=5199b32f&scoped=true"
import script from "./OrdemTrabalho.vue?vue&type=script&lang=js"
export * from "./OrdemTrabalho.vue?vue&type=script&lang=js"
import style0 from "./OrdemTrabalho.vue?vue&type=style&index=0&id=5199b32f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199b32f",
  null
  
)

export default component.exports